import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { subscribeJobs, dismissJob, retryDownload, resumeJobs } from "@/lib/jobs";

const pct = (j) => (j.status !== "running" ? 100 : j.total ? Math.round((j.done / j.total) * 100) : null);

const JobCard = ({ job }) => {
  const p = pct(job);
  const failed = job.status === "failed";
  const done = job.status === "done";
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-lg p-3 w-72 uemp-fade-in" data-testid={`job-card-${job.id}`}>
      <div className="flex items-start gap-2">
        {failed ? <Icons.XCircle className="h-4 w-4 text-red-500 mt-0.5 shrink-0" /> : done ? <Icons.CheckCircle2 className="h-4 w-4 text-emerald-500 mt-0.5 shrink-0" /> : <Icons.Loader2 className="h-4 w-4 text-sky-600 animate-spin mt-0.5 shrink-0" />}
        <div className="min-w-0 flex-1">
          <div className="text-xs font-medium text-slate-800 truncate" data-testid="job-label">{job.label}</div>
          <div className={`text-[11px] truncate ${failed ? "text-red-600" : "text-slate-500"}`} data-testid="job-message">{failed ? job.error : job.message}</div>
        </div>
        {!job.status || job.status === "running" ? null : (
          <button onClick={() => dismissJob(job.id)} className="text-slate-400 hover:text-slate-700" data-testid="job-dismiss-btn"><Icons.X className="h-3.5 w-3.5" /></button>
        )}
      </div>
      <div className="mt-2 flex items-center gap-2">
        {p === null ? <div className="h-2 flex-1 rounded-full bg-sky-100 overflow-hidden"><div className="h-full w-1/3 bg-sky-500 animate-pulse rounded-full" /></div>
          : <Progress value={p} className={`h-2 flex-1 ${failed ? "[&>div]:bg-red-500" : ""}`} data-testid="job-progress" />}
        <span className="text-[11px] tabular-nums text-slate-500 w-9 text-right" data-testid="job-percent">{p === null ? "…" : `${p}%`}</span>
      </div>
      {done && job.file_path && (
        <button onClick={() => retryDownload(job)} className="mt-2 text-[11px] text-sky-700 hover:underline flex items-center gap-1" data-testid="job-download-btn"><Icons.Download className="h-3 w-3" />Download {job.filename}</button>
      )}
    </div>
  );
};

export const JobTray = () => {
  const [jobs, setJobs] = useState([]);
  useEffect(() => subscribeJobs(setJobs), []);
  useEffect(() => { resumeJobs(); }, []);
  if (!jobs.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[60] flex flex-col gap-2 max-w-[calc(100vw-2rem)]" data-testid="job-tray">
      {jobs.map((j) => <JobCard key={j.id} job={j} />)}
    </div>
  );
};
